/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateProfileRequest
 */
export interface UpdateProfileRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateProfileRequest
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileRequest
     */
    account: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileRequest
     */
    currentPassword?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileRequest
     */
    newPassword?: string;
}

export function UpdateProfileRequestFromJSON(json: any): UpdateProfileRequest {
    return UpdateProfileRequestFromJSONTyped(json, false);
}

export function UpdateProfileRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProfileRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'account': json['account'],
        'name': json['name'],
        'email': json['email'],
        'currentPassword': !exists(json, 'currentPassword') ? undefined : json['currentPassword'],
        'newPassword': !exists(json, 'newPassword') ? undefined : json['newPassword'],
    };
}

export function UpdateProfileRequestToJSON(value?: UpdateProfileRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'account': value.account,
        'name': value.name,
        'email': value.email,
        'currentPassword': value.currentPassword,
        'newPassword': value.newPassword,
    };
}


